import Nav from 'components/Nav';
import ProductItem from 'components/ProductItem';
import MoreTitle from '../more';
import {observer, inject} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    bqdlc: store.bqdlc,
    tabClick: store.tabClick,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class AroundSummer extends React.Component {
    tabClick(keyName, index) {
        this.props.tabClick('bqdlc', keyName, index);
    }
    getTypeValue(data) {
        let dpj = '', lvj = '', result;
        result = data.filter(v => {
            if(v.display === undefined && !v.display.includes('mobile_list')) {
                return false;
            }

            if(v.tag_type === 'shopAllianceCoupon' && v.type === 'sales') {
                !dpj && v.amount && (dpj = (v.reduce_type === 1 ? '每满' : '满') + v.amount + '减' + v.reduce);
                return false;
            }
            if(v.tag_type === 'promotion' && v.type === 'sales') {
                !lvj && v.money && (lvj = '最高 满' + v.money + '减' + v.reduce);
                return false;
            }
            return true;
        });

        let dataSum = [];
        result = result.filter((t) => {
            if(dataSum.includes(t.title)) return false;
            dataSum.push(t.title);
            return true;
        });
        return {
            dpj,
            lvj,
            result
        };
    }
    pRend(data) {
        const {ymbj} = this.props;
        let tags = data.data.tags ? data.data.tags : [];
        const promoteDesc = ymbj.promoteDesc;

        let dpjContent = '', lvjContent = '';
        if(data.tagInfos) {
            let {dpj, lvj, result} = this.getTypeValue(data.tagInfos, 'tag_type', 'shopAllianceCoupon', 'title');
            dpjContent = dpj;
            lvjContent = lvj;
            !tags.length && (tags = result);
        }
        return (
            <div className="pro-info ">
                <div className="tit">{data.title}</div>
                <div className="tags lr-tags">
                    {
                        tags && tags.map((item) => {
                            const text = item.tag || item.title;
                            if(!text) return null;
                            return <div className="tags-item">{text}</div>;
                        })
                    }
                </div>
                <div className="dpmj-item">
                    瓜分可得
                    <span className="line"></span>
                    {lvjContent ? lvjContent : promoteDesc}
                </div>
                <div className={`${dpjContent ? 'dpmj-item': 'empty-item'}`}>
                    {
                        dpjContent ?
                            <div>
                                店铺劵
                                <span className="line"></span>
                                {dpjContent}
                            </div> : ''
                    }
                </div>
                <div className="price-info">
                    <div className="price lr-price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                    <div className={`btn ${data.status === 2 ? 'soldout' : 'lr-btn'}`} >{data.status === 2 ? '已售罄' : '立即购买'}</div>
                </div>
            </div>
        );
    }
    render() {
        const {bqdlc, jump, ymbj} = this.props;
        const {bqdlcFirstTab, pros} = bqdlc;
        if(pros.length <= 0 || (ymbj.bqdlc && ymbj.bqdlc.switch !== 1)) return null;
        return (
            <div className="m-uncertainFloor m-floor" id="bqdlc">
                <ModuleTitle name="bqdlc"/>
                <Nav
                    tabs={bqdlcFirstTab}
                    tabClick={(keyName, index)=> {
                        this.tabClick(keyName, index);
                        sendSK('click_bqd_tab' + (index + 1));
                    }}
                    navCls="common-navitem"
                    navClsAct="common-navactive"
                    moreCls="common-navitem"
                    dbackCls="common-drawback"
                    keyName="bqdlcFirstTab"
                />
                {
                    pros.length ?
                        <div className="pro-lists">
                            {
                                pros.map((item, index) => {
                                    if(index > 5) return null;
                                    return <ProductItem
                                        custCls="lr-item"
                                        pRendeStatus={true}
                                        data={item}
                                        jump={() => {
                                            jump(item.jumpInfo, 'shuqi_bqd');
                                            sendSK('click_bqd', {
                                                floor: '不确定',
                                                id: item.id
                                            });
                                        }} key={index}
                                        pRend={this.pRend.bind(this)}
                                    />;
                                })
                            }
                        </div> : ''
                }
                {
                    pros.length ?
                        <MoreTitle
                            bgUrl={'//s.qunarzz.com/vacation_tuan/2020/06_shuchu/more-bg.png'}
                            text="查看更多"
                            ClickMore={() => {
                                let item = bqdlcFirstTab.filter((val) => val.checked)[0];
                                jump(item.more, 'shuqi_bqd_more');
                                sendSK('click_bqd_more', {
                                    floor: '不确定'
                                });
                            }}
                        /> : ''
                }
            </div>
        );
    }
}

export default AroundSummer;